import { createContext } from 'react';

const HeaderHeightContext = createContext(0);

export default HeaderHeightContext;
